module.exports.VIEW_TYPES = { INCIDENTS: 'incidents', REPORTS: 'reports' };
